export enum LessonState {
  IDLE = 'idle',
  START = 'start',
  CONTINUE = 'continue',
}

export interface LessonWithState {
  id: string;
  label: string;
  title: string;
  description: string;
  emoji: string;
  hasBeenStarted: boolean;
  progress: number;
  onClick: () => void;
  state: LessonState;
}